import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Layout from "./components/Layout";
import { LanguageProvider } from "./i18n/LanguageContext";

import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Aftercare from "./pages/Aftercare";
import BedRentals from "./pages/BedRentals";
import Training from "./pages/Training";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Tattoos from "./pages/Tattoos";
import ServicesIndex from "./pages/ServicesIndex";
import BrowLaminationPage from "./pages/BrowLaminationPage";
import LashesPage from "./pages/LashesPage";
import EyelinerTattooPage from "./pages/EyelinerTattooPage";

import { SERVICES } from "./data/services";

import "@/App.css";

const ScrollToTop = () => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    });
    return null;
};

// Hide Emergent badge
const HideEmergentBadge = () => {
    useEffect(() => {
        const hideBadge = () => {
            // Find and hide any element containing "Made with Emergent"
            const allElements = document.querySelectorAll('*');
            allElements.forEach(el => {
                if (el.textContent && el.textContent.includes('Made with Emergent') && el.children.length === 0) {
                    let parent = el.closest('div[style*="position"]') || el.parentElement;
                    if (parent) parent.style.display = 'none';
                }
            });
            // Also target fixed position elements at bottom-right
            document.querySelectorAll('div[style*="fixed"]').forEach(el => {
                if (el.textContent && el.textContent.includes('Emergent')) {
                    el.style.display = 'none';
                }
            });
        };
        hideBadge();
        const interval = setInterval(hideBadge, 1000);
        return () => clearInterval(interval);
    }, []);
    return null;
};

function App() {
    return (
        <HelmetProvider>
            <LanguageProvider>
                <BrowserRouter>
                    <HideEmergentBadge />
                    <Layout>
                        <Routes>
                            <Route path="/" element={<><ScrollKey /><Home /></>} />
                            <Route path="/services" element={<><ScrollKey /><ServicesIndex /></>} />
                            {/* Custom pages for specific services */}
                            <Route path="/brow-lamination" element={<><ScrollKey /><BrowLaminationPage /></>} />
                            <Route path="/lashes" element={<><ScrollKey /><LashesPage /></>} />
                            <Route path="/eyeliner-tattoo" element={<><ScrollKey /><EyelinerTattooPage /></>} />
                            {/* Generic service pages */}
                            {SERVICES.filter(s => s.slug !== 'brow-lamination' && s.slug !== 'lashes' && s.slug !== 'eyeliner-tattoo').map((s) => (
                                <Route
                                    key={s.slug}
                                    path={`/${s.slug}`}
                                    element={
                                        <>
                                            <ScrollKey />
                                            <ServicePage
                                                serviceKey={s.key}
                                                gallery={s.gallery}
                                                heroImage={s.heroImage || s.image}
                                            />
                                        </>
                                    }
                                />
                            ))}
                            <Route path="/aftercare" element={<><ScrollKey /><Aftercare /></>} />
                            <Route path="/bed-rentals" element={<><ScrollKey /><BedRentals /></>} />
                            <Route path="/training" element={<><ScrollKey /><Training /></>} />
                            <Route path="/about" element={<><ScrollKey /><About /></>} />
                            <Route path="/contact" element={<><ScrollKey /><Contact /></>} />
                            <Route path="/tattoos" element={<><ScrollKey /><Tattoos /></>} />
                            <Route path="*" element={<><ScrollKey /><Home /></>} />
                        </Routes>
                    </Layout>
                </BrowserRouter>
            </LanguageProvider>
        </HelmetProvider>
    );
}

const ScrollKey = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);
    return null;
};

export default App;
